var map = {
	"./admiracion.svg": 49457,
	"./approved.svg": 15766,
	"./audio-yellow.svg": 16497,
	"./audiob.svg": 20994,
	"./audiopsicologo.svg": 6589,
	"./badge.svg": 67036,
	"./calendar-white.svg": 41285,
	"./calendar.svg": 90874,
	"./calendariof.svg": 57481,
	"./check-invalid.svg": 68931,
	"./check.svg": 90706,
	"./copiar.svg": 54206,
	"./copiarf.svg": 73311,
	"./cortesia.svg": 67349,
	"./download.svg": 39007,
	"./entrarf.svg": 25797,
	"./expand.svg": 20951,
	"./googlecalendaricon.svg": 12534,
	"./info.svg": 67292,
	"./pause.svg": 77888,
	"./pauseb.svg": 19657,
	"./pausewhite.svg": 28563,
	"./reply-invert.svg": 85865,
	"./trash.svg": 10967,
	"./upload.svg": 10377
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 87254;